import React from "react";
import { Heart, Instagram } from "lucide-react";
import { SOCIAL_POSTS } from "../data/site";

const TikTokIcon = ({ size = 14 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.83A8.16 8.16 0 0 0 21.42 10V6.69a4.85 4.85 0 0 1-1.83 0Z" />
  </svg>
);

const SocialGrid = () => {
  return (
    <section className="container-x py-20 md:py-28" data-testid="social-grid">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12">
        <div className="md:col-span-7">
          <p className="overline mb-4">Social</p>
          <h2 className="font-display uppercase text-4xl md:text-6xl tracking-tight font-bold leading-[0.95]">
            Worn by players who
            <br />
            <span className="text-mute">care about the details.</span>
          </h2>
        </div>
        <div className="md:col-span-5 flex md:items-end">
          <p className="text-mute max-w-md leading-relaxed">
            Pritch on academy pitches, Sunday League sides, semi-pro setups and player ambassadors —
            tag <span className="font-semibold text-ink">@pritchwear</span> to feature.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-line border border-line">
        {SOCIAL_POSTS.map((p, idx) => (
          <a
            key={`${p.handle}-${idx}`}
            href={p.platform === "instagram" ? "https://instagram.com" : "https://tiktok.com"}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white relative aspect-square block overflow-hidden"
            data-testid={`social-post-${idx}`}
          >
            <img
              src={p.image}
              alt={p.caption}
              className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-500"
            />
            <div className="absolute inset-x-0 top-0 p-3 flex items-center justify-between">
              <span className="mono text-[10px] tracking-widest uppercase bg-white/85 backdrop-blur-sm px-2 py-1 text-ink border border-line">
                {p.handle}
              </span>
              <span className="bg-white/85 backdrop-blur-sm border border-line p-1 text-ink">
                {p.platform === "instagram" ? <Instagram size={12} /> : <TikTokIcon size={12} />}
              </span>
            </div>
            <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/65 to-transparent">
              <p className="text-[11px] text-white leading-snug line-clamp-2">{p.caption}</p>
              <div className="flex items-center gap-1 mt-1.5 text-white/80">
                <Heart size={10} strokeWidth={1.6} />
                <span className="mono text-[10px]">{p.likes}</span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default SocialGrid;
